import { History } from "history";
import { SagaIterator } from "redux-saga";

import { AppState } from "@/mk2/reducers";
import { createBrowserXhr } from "@/mk2/services/browserXhr";
import { Store, configureStore } from "@/mk2/store/configureStore";

// TODO @types: Add typing for rootSagas
export function initStore(
    history: History,
    rootSagas: (() => SagaIterator) | null,
    initialState: Partial<AppState> = {},
): Store<AppState> {
    const xhr = createBrowserXhr();
    const store: Store<AppState> = configureStore<AppState>(history, xhr, initialState);

    if (rootSagas) {
        store.injectSaga("root", rootSagas);
    }

    return store;
}
